(function () {
  'use strict';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animated = new WeakSet();
  // Animate visible content without ever hiding content before JavaScript runs.
  const reveal = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      if (!reducedMotion.matches && typeof entry.target.animate === 'function') {
        entry.target.animate([
          { opacity: 0.45, transform: 'translateY(18px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 480, easing: 'ease-out' });
      }
      reveal.unobserve(entry.target);
    });
  }, { threshold: 0.12 }) : null;

  function enhance(root) {
    root.querySelectorAll('.service,.steps li,.section-heading,.questions>div,.enquiry-card').forEach(function (el) {
      if (reveal && !animated.has(el)) { animated.add(el); reveal.observe(el); }
    });
    const faqs = root.querySelector('.faqs');
    if (faqs && !faqs.querySelector('.pa-faq-tools')) {
      const tools = document.createElement('div');
      tools.className = 'pa-faq-tools';
      const label = document.createElement('label');
      label.textContent = 'Find an answer';
      const search = document.createElement('input');
      search.type = 'search';
      search.placeholder = 'Try “referral” or “home”…';
      search.setAttribute('aria-label', 'Search frequently asked questions');
      label.appendChild(search);
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.textContent = 'Expand answers';
      toggle.setAttribute('aria-expanded', 'false');
      const status = document.createElement('p');
      status.className = 'pa-faq-status';
      status.setAttribute('role', 'status');
      tools.appendChild(label);
      tools.appendChild(toggle);
      tools.appendChild(status);
      faqs.prepend(tools);
      const answers = Array.from(faqs.querySelectorAll('details'));
      function syncToggle() {
        const visible = answers.filter(function (answer) { return !answer.hidden; });
        const allOpen = visible.length > 0 && visible.every(function (answer) { return answer.open; });
        toggle.textContent = allOpen ? 'Collapse answers' : 'Expand answers';
        toggle.setAttribute('aria-expanded', String(allOpen));
        toggle.disabled = visible.length === 0;
      }
      search.addEventListener('input', function () {
        const query = search.value.trim().toLocaleLowerCase();
        let count = 0;
        answers.forEach(function (answer) {
          answer.hidden = !answer.textContent.toLocaleLowerCase().includes(query);
          if (!answer.hidden) count++;
        });
        status.textContent = query ? (count ? count + ' matching answer' + (count === 1 ? '' : 's') : 'No matching answers. Try another word or contact us below.') : '';
        syncToggle();
      });
      toggle.addEventListener('click', function () {
        const expand = toggle.getAttribute('aria-expanded') !== 'true';
        answers.forEach(function (answer) { if (!answer.hidden) answer.open = expand; });
        syncToggle();
      });
      answers.forEach(function (answer) { answer.addEventListener('toggle', syncToggle); });
    }
    const select = root.querySelector('#audience');
    if (select && !select.parentElement.querySelector('.pa-audience')) {
      const group = document.createElement('div');
      group.className = 'pa-audience';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', 'Choose your enquiry type');
      [['patient', 'Patient / carer'], ['referrer', 'Referrer'], ['facility', 'Aged care']].forEach(function (item) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = item[1];
        button.dataset.value = item[0];
        button.addEventListener('click', function () {
          select.value = item[0];
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        group.appendChild(button);
      });
      function sync() {
        group.querySelectorAll('button').forEach(function (button) {
          button.setAttribute('aria-pressed', String(button.dataset.value === select.value));
        });
      }
      select.insertAdjacentElement('beforebegin', group);
      select.addEventListener('change', sync);
      sync();
      const title = root.querySelector('#enquiryTitle');
      if (title) title.setAttribute('aria-live', 'polite');
    }
    const message = root.querySelector('#ContactMessage');
    if (message && !root.querySelector('.pa-count')) {
      const counter = document.createElement('span');
      counter.className = 'pa-count';
      counter.id = 'pa-message-count';
      message.insertAdjacentElement('afterend', counter);
      message.setAttribute('aria-describedby', (message.getAttribute('aria-describedby') || '') + ' pa-message-count');
      function count() { counter.textContent = message.value.length + ' / ' + message.maxLength + ' characters'; }
      message.addEventListener('input', count);
      count();
    }
  }
  enhance(document);
  document.addEventListener('change', function (event) {
    if (event.target.id === 'audience') {
      document.querySelectorAll('.pa-audience button').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.value === event.target.value));
      });
    }
  });
  // Existing service links update the native select without emitting change.
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-audience]')) {
      const select = document.getElementById('audience');
      if (select) select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('shopify:section:load', function (event) { enhance(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (reveal) event.target.querySelectorAll('.service,.steps li,.section-heading,.questions>div,.enquiry-card').forEach(function (el) { reveal.unobserve(el); });
  });
  const progress = document.createElement('div');
  progress.className = 'pa-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');
  document.body.appendChild(progress);
  const back = document.createElement('button');
  back.type = 'button';
  back.className = 'pa-back-top';
  back.textContent = '↑ Back to top';
  back.hidden = true;
  document.body.appendChild(back);
  back.addEventListener('click', function () {
    const home = document.querySelector('header .brand');
    if (home) home.focus({ preventScroll: true });
    window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
  });
  const links = Array.from(document.querySelectorAll('header nav a'));
  let queued = false;
  function updateScroll() {
    queued = false;
    const distance = document.documentElement.scrollHeight - window.innerHeight;
    const position = Math.max(0, window.scrollY);
    progress.style.transform = 'scaleX(' + (distance > 0 ? Math.min(1, position / distance) : 0) + ')';
    // Do not hide a keyboard-focused control while the page is scrolling.
    back.hidden = position < 450 && document.activeElement !== back;
    let current = null;
    links.forEach(function (link) {
      const url = new URL(link.href, window.location.href);
      const section = url.pathname === window.location.pathname ? document.getElementById(url.hash.slice(1)) : null;
      if (section && section.getBoundingClientRect().top <= window.innerHeight * 0.35) current = link;
    });
    links.forEach(function (link) {
      if (link === current) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(updateScroll); } }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  back.addEventListener('blur', queue);
  updateScroll();
})();
